import type { useAdminColors } from '@/hooks/admin/useAdminColors';
import { hexToRgba } from '@/utils/shared/color';

type AdminColors = ReturnType<typeof useAdminColors>;
type ThemeMode = AdminColors['mode'];

// hexToRgba now lives in the shared color utils (the resident redesign needs
// it too, for alpha-derived gradient stops). Re-exported here so the admin
// call sites that already import it from this module keep working.
export { hexToRgba };

export interface TagPillColorSlots {
  bg: string;
  border: string;
  text: string;
  iconOpacity: number;
}

export function tagPillColors(
  hex: string | null,
  disabled: boolean,
  mode: ThemeMode,
  redesign: AdminColors['redesign'],
): TagPillColorSlots {
  if (disabled || !hex) {
    return {
      bg: redesign.glass.buttonBg,
      border: redesign.card.border,
      text: redesign.text.subtle,
      iconOpacity: disabled ? 0.5 : 1,
    };
  }

  const bgAlpha = mode === 'light' ? 0.18 : 0.15;
  const borderAlpha = mode === 'light' ? 0.55 : 0.4;

  return {
    bg: hexToRgba(hex, bgAlpha),
    border: hexToRgba(hex, borderAlpha),
    text: hex,
    iconOpacity: 1,
  };
}
